export const SET_SHARED_PAGE_INFO = 'shared-page/SET_SHARED_PAGE_INFO';
export const SET_SHARED_PAGE = 'shared-page/SET_SHARED_PAGE';
export const SET_SHARED_PAGE_RESULTS = 'shared-page/SET_SHARED_PAGE_RESULTS';
export const SET_SHARED_QUIZ_OPTION = 'shared-page/SET_SHARED_QUIZ_OPTION';
